import React, { useEffect, useRef, useState, useTransition } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ClipPathIcon } from "../../../assets/svg";
import { colors } from "../../../constants/colors";
import { routes } from "../../../constants";
import { baseRouteMaker } from "../../../constants/routeConsts";
import { GetCardLayout } from "../getCardLayout";
import "./Tabs.scss";

const Tabs = ({ tabsMenuUtils, isBoxLayout, disabled }) => {
  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  /* navigation dependencies */
  const navigate = useNavigate();
  const location = useLocation();
  /* navigation dependencies */

  /* ref dependencies */
  const indicatorRef = useRef(null);
  const anchorTagRef = useRef(null);
  /* ref dependencies */

  const [isPending, startTransition] = useTransition();

  useEffect(() => {
    if (tabsMenuUtils && tabsMenuUtils !== undefined) {
      startTransition(() => {
        const tempTabMenuUtils = [...tabsMenuUtils];
        const tabIndex = tempTabMenuUtils.findIndex(
          (element) => element.url === location.pathname
        );
        setCurrentTabIndex(tabIndex);
        navigate(tempTabMenuUtils[tabIndex]?.url, { replace: true });
      });
    }
    if (anchorTagRef.current) {
      indicatorRef.current.style.left = anchorTagRef.current.offsetLeft + "px";
      indicatorRef.current.style.width =
        anchorTagRef.current.offsetWidth + "px";
    }
  }, [location.pathname, currentTabIndex]);

  /* on tab change set current tab index */
  const onTabChanged = (event, element, index) => {
    startTransition(() => {
      setCurrentTabIndex(index);
      indicatorRef.current.style.left = event.target.offsetLeft + "px";
      indicatorRef.current.style.width = event.target.offsetWidth + "px";
      navigate(element.url, { replace: true });
    });
  };
  /* on tab change set current tab index */

  return (
    <>
      <div className="tabs-wrapper">
        <nav className="tabs-container">
          {tabsMenuUtils?.map((element, index) => {
            return (
              <a
                ref={index === currentTabIndex ? anchorTagRef : null}
                className={`tab ${
                  index === currentTabIndex ? "tab-active" : ""
                } ${
                  disabled || element?.id === "autoCredit" ? "tab-disabled" : ""
                }`}
                onClick={(event) => onTabChanged(event, element, index)}
              >
                {element.title}
              </a>
            );
          })}
          <div className="indicator" ref={indicatorRef}>
            <div className="indicator-container"></div>
            <div className="svg-container">
              <ClipPathIcon fillColor={colors.primaryColor} />
            </div>
          </div>
        </nav>
      </div>
      {location.pathname.includes(baseRouteMaker(routes.DASHBOARD)) ||
      location.pathname.includes(baseRouteMaker(routes.CHAT)) ? (
        <Outlet />
      ) : (
        <GetCardLayout>
          <Outlet />
        </GetCardLayout>
      )}
    </>
  );
};

export default Tabs;
